import React, { Component } from 'react'
import img from '../../images/room-svc/sub_meals/sub_meal01.png'
import img2 from '../../images/room-svc/sub_meals/sub_meal02.png'
import img3 from '../../images/room-svc/sub_meals/sub_meal03.png'
import img4 from '../../images/room-svc/sub_meals/sub_meal04.png'
import { changePage, selectedFood, getItemList, defaultStoreItemList } from '../../action/hcommerce'
import { connect } from 'react-redux'
import propTypes from 'prop-types';
import { CMSPath } from '../../config/constant'
import defaultImage from '../../images/cover_breakfast.png'
import { hCommButtonColor } from '../../JS/setColors'

class MenuItem extends Component {
    goBack = () => {
        this.props.changePage("StoreSubItemType");
    }
    goToItemInfo = (nextPage, selecteditem) => {
        this.props.changePage(nextPage);
        this.props.selectedFood(selecteditem);
    }
    componentDidMount() {
        hCommButtonColor(this.props.menuColor)
        if (this.props.SelectedSubItem.id) {
            this.props.getItemList(this.props.guestDetail, this.props.SelectedSubItem.id);
        }
    }

    componentWillUnmount() {
        this.props.defaultStoreItemList([])
    }
    render() {
        let imagePath
        return (
            <div id="rs-item-list" class="movie-widgets" style={{ color: "inherit" }}>
                <div class="search-back" data-target="rs-menu-list" onClick={this.goBack}>
                    <i class="fa fa-chevron-left" style={{ color: "inherit" }}></i> Back</div>
                <h4 style={{ color: "inherit" }}>{this.props.SelectedSubItem ? this.props.SelectedSubItem.subTypeName : null}</h4>
                <ul class="movie-widgets-list">
                    {
                        this.props.storeItemList.map((iterator) => {
                            if (iterator.storeItemImages.length === 1) {
                                imagePath = `${CMSPath}${iterator.storeItemImages[0].imagePath}`
                            } else {
                                iterator.storeItemImages.map((images) => {
                                    if (images.imageType === "LARGE") {
                                        imagePath = encodeURI(`${CMSPath}${images.imagePath}`);
                                        if (imagePath.indexOf('(') !== -1) {
                                            imagePath = imagePath.replace("(", "%28");
                                        }
                                        if (imagePath.indexOf(')') !== -1) {
                                            imagePath = imagePath.replace(")", "%29");
                                        }
                                        //console.log("imagePath", imagePath);
                                    }
                                })
                            }
                            // if (iterator.storeItemImages.length === 0) {
                            //     imagePath = //`${CMSPath}/../cmsData/hCommerce/defaultImages/default.png `
                            //     defaultImage
                            // }
                            return (
                                <li onClick={() => { this.goToItemInfo("itemInfo", iterator) }}
                                    data-target="rs-item-list"
                                    style={{
                                        background: `url(${imagePath}) center center no-repeat`,
                                        backgroundSize: "cover"
                                    }}>
                                    <a ><span>{iterator.itemName}</span></a>
                                </li>
                            )
                        })
                    }

                </ul>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        SelectedSubItem: state.store.Hcommerce.SelectedSubItem,
        storeItemList: state.store.Hcommerce.storeItemList,
        menuColor: state.store.home.MenuColor
    }
}

export default connect(
    mapStateToProps,
    {
        changePage,
        selectedFood,
        getItemList,
        defaultStoreItemList
    }
)(MenuItem);

/* <li onClick={() => { this.goToItemInfo("itemInfo", "Bacon and Egg") }}
    data-target="rs-item-list"
    style={{
        background: `url(${img}) center center no-repeat`,
        backgroundSize: "cover"
    }}>
    <a ><span>Bacon and Egg</span></a>
</li> */